var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWiscjLink = function SvgWiscjLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 1928 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0b40a3",
    d: "M211.497 511.902c0-158.897 129.079-287.975 287.975-287.975h371.543V47.375H499.472c-256.392 0-464.527 208.135-464.527 464.527S243.08 976.429 499.472 976.429h371.543V799.877H499.472c-158.897 0-287.975-129.079-287.975-287.975m380.959 92.984h743.087V418.918H592.456zm836.071-557.315h-371.543v176.552h371.543c158.897 0 287.975 129.079 287.975 287.975s-129.079 287.975-287.975 287.975h-371.543v176.552h371.543c256.392 0 464.527-208.135 464.527-464.527S1684.919 47.571 1428.527 47.571"
  })));
};
export default SvgWiscjLink;